<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Scheme Duration</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.duration }}</td>
        <td class="text-xs-left">{{ props.item.durationDesc }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click.native="doNew()">New Duration<v-icon>mdi-plus</v-icon></v-btn>
    <v-dialog v-model="durationDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Permit Duration for Scheme</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete :label="labels.duration" v-model="durationForm.duration" :items="durationList" item-text="label" item-value="value" :error-messages="errors.first('scheme') ? errors.first('scheme') : errors.collect('duration')" data-vv-name="duration" :data-vv-as="labels.duration" v-validate="'required'" :loading="durationLoading"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Scheme?
      <div class="title">{{deleteDuration}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
export default {
  data() {
    return {
      headers: [
        { text: 'Duration', value: 'duration' },
        { text: 'Duration Description', value: 'durationDesc' },
        TableConst.tableActionHeader
      ],
      durationForm: {
        scheme: null,
        duration: null
      },
      labels: {
        duration: 'Duration*'
      },
      durationList: [],
      durationLoading: false,
      durationDialog: false,
      deleteDuration: '',
      promptRemove: false
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  methods: {
    async doInit() {
      this.durationForm.scheme = this.scheme
      await this.fetchData(this.scheme)
    },
    async fetchData(xscheme) {
      const apiURI = this.schemeMenu.menu.schemeDurations
      if (apiURI) {
        try {
          const expand = {
            scheme: xscheme
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((duration) => {
              const convertList = {
                duration: duration.duration,
                durationDesc: duration.durationDesc
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Product Duration')
      }
    },
    async getDurations() {
      const apiURI = this.schemeMenu.menu.durationList
      if (apiURI) {
        try {
          this.durationLoading = true
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.durationList = data
          }
          this.durationLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Duration List')
      }
    },
    async doNew() {
      this.resetMessages()
      this.durationForm.duration = undefined
      this.durationDialog = true
      await this.getDurations()
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doCreate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.schemeMenu.menu.schemeDurationCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.durationForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.doInit()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Create Product Duration')
      }
    },
    doClose() {
      this.resetMessages()
      this.durationForm.duration = undefined
      this.durationDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedDuration = data
        this.deleteDuration = data.duration + ' - ' + data.durationDesc
      }
    },
    async doRemove() {
      const apiURI = this.schemeMenu.menu.schemeDurationDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          duration: this.selectedDuration.duration,
          scheme: this.scheme
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.loading = false
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Scheme Duration')
      }
    }
  },
  mounted() {
    Promise.all([this.doInit()])
    if (this.scheme === 'new') {
      this.newDuration = true
    }
  },
  props: {
    scheme: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
